module.exports = __webpack_public_path__ + "media/images/background/1-7219b5315ae5bd7746baf9350ee926f8.jpg";